"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var Subject_1 = require("rxjs/Subject");
var entity_select_picker_settings_component_1 = require("./settings/entity-select-picker-settings.component");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var Observable_1 = require("rxjs/Observable");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var material_1 = require("@angular/material");
var type_configuration_service_1 = require("../../shared/services/api/type-configuration.service");
var form_resolution_service_1 = require("../../shared/services/api/form-resolution.service");
var operators_1 = require("rxjs/operators");
var type_subtype_select_dialog_data_1 = require("../../shared/dialogs/advanced/type-subtype-select/model/type-subtype-select-dialog-data");
var type_subtype_select_dialog_component_1 = require("../../shared/dialogs/advanced/type-subtype-select/type-subtype-select-dialog.component");
var dialog_config_helper_1 = require("../../shared/utils/dialog-config-helper");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var root_category_provider_service_1 = require("../../shared/services/api/root-category-provider.service");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var EntitySelectPickerComponent = /** @class */ (function () {
    function EntitySelectPickerComponent(entitySearchService, typeConfigurationService, formResolutionService, rootCategoryProviderService, classifierService, kbService, dialog, formResolverService, localeService, currentLanguageProvider) {
        var _this = this;
        this.entitySearchService = entitySearchService;
        this.typeConfigurationService = typeConfigurationService;
        this.formResolutionService = formResolutionService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.classifierService = classifierService;
        this.kbService = kbService;
        this.dialog = dialog;
        this.formResolverService = formResolverService;
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.typeIds = [];
        this.subTypeIds = [];
        this.WFStateIds = [];
        this.displayFields = [];
        this.displayFieldSystemNames = [];
        this.isCreateButtonDisabled = true;
        this._typeClassifiers = [];
        this._destroy$ = new Subject_1.Subject();
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.switchMap(function (language) { return _this.localeService.getLocaleInfo(language.getId()); }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (value) {
            _this._localeInfo = value;
        });
    }
    EntitySelectPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.entity && this.targetEntityMetaField) {
            this.displayFieldSystemNames = this.displayFields &&
                this.displayFields.map(function (field) { return field['metaFieldId']['systemName']; }) || [];
            this._targetFieldSystemName = this.targetEntityMetaField['metaFieldId']['systemName'];
            this.selectedEntity = this.entity.getProperty(this._targetFieldSystemName).value;
            this.targetEntityCategoryName = this.targetEntityMetaField['compoundCategorySystemName'];
            var entityTypeConfigs$ = this.typeConfigurationService.getTypedCategoryProperties(this.targetEntityCategoryName);
            entityTypeConfigs$.pipe(operators_1.switchMap(function (entityTypeConfigs) {
                _this._entityTypeConfigs = entityTypeConfigs;
                if (!_this.isReadonly) {
                    if (_this.hasCreateButton) {
                        _this.actionNotifier.takeUntil(_this._destroy$)
                            .subscribe(function (action) {
                            if (_this._isDrawerOpened) {
                                if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_SAVE_ACTION) {
                                    var responseEntity = action.data.getData();
                                    _this._drawerEntity = responseEntity.getId() !== -1 ? responseEntity : null;
                                }
                                else if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_CLOSE_ACTION) {
                                    _this._isDrawerOpened = false;
                                    if (_this._drawerEntity) {
                                        _this.availableEntities.push(_this._drawerEntity);
                                        _this.onEntitySelect(_this._drawerEntity);
                                    }
                                }
                            }
                        });
                    }
                    return _this.rootCategoryProviderService.getRootEntityId(_this.rootCategoryId, _this.category, _this.entity);
                }
            }), operators_1.concatMap(function (rootEntityId) {
                var _a;
                if (rootEntityId) {
                    _this._rootEntityId = rootEntityId;
                    _this.filter['$and'].push((_a = {}, _a[_this.rootCategoryFieldName] = rootEntityId, _a));
                    return _this.kbService.getMainEntityMetaFields(_this.category, _this._targetFieldSystemName);
                }
                else {
                    _this.noRootEntityId = true;
                    return of_1.of(null);
                }
            }), operators_1.concatMap(function (metaFields) {
                var availableEntities = metaFields ?
                    _this.entitySearchService.loadPortfolioItemsByFields(_this.targetEntityCategoryName, new idm_de_core_frontend_1.PagingOptions(0, 100), null, _this.filter, null, null, metaFields.map(function (metaField) { return metaField.getSystemName(); }))
                    :
                        of_1.of([]);
                var typeClassifiers$ = _this.loadTypeClassifiers();
                return zip_1.zip(availableEntities, typeClassifiers$);
            }), operators_1.takeUntil(this._destroy$), operators_1.take(1)).subscribe(function (_a) {
                var availableEntities = _a[0], typeClassifiers = _a[1];
                if (typeClassifiers && typeClassifiers.length) {
                    _this._typeClassifiers = typeClassifiers;
                    _this.isCreateButtonDisabled = false;
                }
                _this._typeClassifiers = typeClassifiers;
                _this.availableEntities = availableEntities ? availableEntities.getData() : [];
                _this.isReady = true;
            });
        }
    };
    EntitySelectPickerComponent.prototype.ngOnInit1 = function () {
        var _this = this;
        if (this.entity && this.targetEntityMetaField) {
            this._targetFieldSystemName = this.targetEntityMetaField['metaFieldId']['systemName'];
            this.targetEntityCategoryName = this.targetEntityMetaField['compoundCategorySystemName'];
            this.selectedEntity = this.entity.getProperty(this._targetFieldSystemName).value;
            if (!this.isReadonly) {
                if (this.hasCreateButton) {
                    this.actionNotifier
                        .takeUntil(this._destroy$)
                        .subscribe(function (action) {
                        if (_this._isDrawerOpened) {
                            if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_SAVE_ACTION) {
                                var responseEntity = action.data.getData();
                                _this._drawerEntity = responseEntity.getId() !== -1 ? responseEntity : null;
                            }
                            else if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_CLOSE_ACTION) {
                                _this._isDrawerOpened = false;
                                if (_this._drawerEntity) {
                                    _this.availableEntities.push(_this._drawerEntity);
                                    _this.onEntitySelect(_this._drawerEntity);
                                }
                            }
                        }
                    });
                }
                var entityTypeConfigs$ = this.typeConfigurationService.getTypedCategoryProperties(this.targetEntityCategoryName);
                var rootEntityId$ = this.rootCategoryProviderService.getRootEntityId(this.rootCategoryId, this.category, this.entity);
                zip_1.zip(entityTypeConfigs$, rootEntityId$).pipe(operators_1.concatMap(function (_a) {
                    var entityTypeConfigs = _a[0], rootEntityId = _a[1];
                    var _b;
                    _this._entityTypeConfigs = entityTypeConfigs;
                    if (rootEntityId) {
                        _this._rootEntityId = rootEntityId;
                        _this.filter['$and'].push((_b = {}, _b[_this.rootCategoryFieldName] = rootEntityId, _b));
                        return _this.kbService.getMainEntityMetaFields(_this.category, _this._targetFieldSystemName);
                    }
                    else {
                        _this.noRootEntityId = true;
                        return of_1.of(null);
                    }
                }), operators_1.concatMap(function (metaFields) {
                    var availableEntities = metaFields ?
                        _this.entitySearchService.loadPortfolioItemsByFields(_this.targetEntityCategoryName, new idm_de_core_frontend_1.PagingOptions(0, 100), null, _this.filter, null, null, metaFields.map(function (metaField) { return metaField.getSystemName(); }))
                        :
                            of_1.of(null);
                    var typeClassifiers$ = _this.loadTypeClassifiers();
                    return zip_1.zip(availableEntities, typeClassifiers$);
                }), operators_1.takeUntil(this._destroy$), operators_1.take(1)).subscribe(function (_a) {
                    var availableEntities = _a[0], typeClassifiers = _a[1];
                    if (typeClassifiers && typeClassifiers.length) {
                        _this._typeClassifiers = typeClassifiers;
                        _this.isCreateButtonDisabled = false;
                    }
                    _this._typeClassifiers = typeClassifiers;
                    _this.availableEntities = availableEntities ? availableEntities.getData() : [];
                    _this.isReady = true;
                });
            }
        }
    };
    EntitySelectPickerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    EntitySelectPickerComponent.prototype.onEntityClick = function () {
        var hasSubType = this.selectedEntity.hasProperty(this._entityTypeConfigs.subType.field);
        var subValue = hasSubType ? this.selectedEntity.getProperty(this._entityTypeConfigs.subType.field).value : null;
        var typeId = this.selectedEntity.getProperty(this._entityTypeConfigs.type.field).value.getId();
        var subTypeId = (this._entityTypeConfigs.subType && hasSubType && subValue) ? subValue.getId() : null;
        if (this.form.inDrawer) {
            this.navigateToSelectedEntity(typeId, subTypeId)
                .takeUntil(this._destroy$)
                .take(1)
                .subscribe();
        }
        else {
            this.openSelectedEntityDrawer(typeId, subTypeId)
                .takeUntil(this._destroy$)
                .take(1)
                .subscribe();
        }
    };
    EntitySelectPickerComponent.prototype.navigateToSelectedEntity = function (typeId, subTypeId) {
        var _this = this;
        return this.formResolutionService.getFormProperties(this.targetEntityCategoryName, typeId, subTypeId)
            .map(function (formProperties) {
            window.open(document.baseURI + _this.formResolverService.getUrlForViewDeFormSync(_this.targetEntityCategoryName, formProperties.viewFormName, _this.selectedEntity.getInstanceId(), formProperties.viewFormId));
        });
    };
    EntitySelectPickerComponent.prototype.openSelectedEntityDrawer = function (typeId, subTypeId) {
        var _this = this;
        return this.formResolutionService.getFormProperties(this.targetEntityCategoryName, typeId, subTypeId)
            .map(function (formProperties) {
            _this.form.actions.editEntityPopup(formProperties.viewFormName, _this.targetEntityCategoryName, formProperties.viewFormId, _this.selectedEntity.getInstanceId());
        });
    };
    EntitySelectPickerComponent.prototype.onCreate = function () {
        this.getTypeDataAndOpenDrawer()
            .takeUntil(this._destroy$)
            .take(1)
            .subscribe();
    };
    EntitySelectPickerComponent.prototype.onDelete = function () {
        this.entity.getProperty(this._targetFieldSystemName).value = null;
        this.selectedEntity = this.entity.getProperty(this._targetFieldSystemName).value;
    };
    EntitySelectPickerComponent.prototype.onEntitySelect = function (mainEntity) {
        this.entity.getProperty(this._targetFieldSystemName).value = mainEntity;
        this.selectedEntity = this.entity.getProperty(this._targetFieldSystemName).value;
    };
    EntitySelectPickerComponent.prototype.openNewEntityDrawer = function (targetEntityCategoryName, dialogResult) {
        var _this = this;
        this._isDrawerOpened = true;
        this._drawerEntity = null;
        return this.formResolutionService.getFormProperties(targetEntityCategoryName, dialogResult && dialogResult.typeId, dialogResult && dialogResult.subTypeId)
            .map(function (formProperties) {
            _this.form.actions.newEntityPopup(formProperties.editFormName, targetEntityCategoryName, formProperties.editFormId, _this.constructTransientFields(dialogResult));
        });
    };
    EntitySelectPickerComponent.prototype.constructTransientFields = function (dialogResult) {
        var _a;
        var data = (_a = {},
            _a[this.targetEntityParentFieldId] = this._rootEntityId,
            _a);
        if (dialogResult) {
            data[this._entityTypeConfigs.type.field] = dialogResult.typeId;
            if (dialogResult.subTypeId) {
                data[this._entityTypeConfigs.subType.field] = dialogResult.subTypeId;
            }
        }
        return data;
    };
    EntitySelectPickerComponent.prototype.openTypeSubTypeSelectDialog = function (dialogData) {
        var _this = this;
        return this.dialog.open(type_subtype_select_dialog_component_1.TypeSubtypeSelectDialogComponent, dialog_config_helper_1.DialogConfigHelper.getTypeSubtypeSelectDialogConfig(dialogData))
            .afterClosed()
            .pipe(operators_1.concatMap(function (dialogResult) {
            if (dialogResult) {
                return _this.openNewEntityDrawer(_this.targetEntityCategoryName, {
                    typeId: dialogResult.type.getId(),
                    subTypeId: dialogResult.subType && dialogResult.subType.getId()
                });
            }
            else {
                return of_1.of(null);
            }
        }));
    };
    EntitySelectPickerComponent.prototype.getTypeDataAndOpenDrawer = function () {
        var _this = this;
        if (this._entityTypeConfigs) {
            if (this._typeClassifiers.length > 1) {
                var dialogData = new type_subtype_select_dialog_data_1.TypeSubtypeSelectDialogData(this._entityTypeConfigs);
                dialogData.typeFilterIds = this.typeIds;
                dialogData.subTypeFilterIds = this.subTypeIds.length && this.subTypeIds;
                return this.openTypeSubTypeSelectDialog(dialogData);
            }
            else if (this._typeClassifiers.length === 1) {
                var typeClassifier_1 = this._typeClassifiers[0];
                return this.loadSubTypeClassifiers(typeClassifier_1.getId()).pipe(operators_1.switchMap(function (subTypeClassifiers) {
                    if (subTypeClassifiers.length > 0) {
                        var filteredSubTypeIds = subTypeClassifiers
                            .filter(function (subTypeClassifier) { return _this.subTypeIds.includes(subTypeClassifier.getId()); })
                            .map(function (subTypeClassifier) { return subTypeClassifier.getId(); });
                        var dialogData = new type_subtype_select_dialog_data_1.TypeSubtypeSelectDialogData(_this._entityTypeConfigs);
                        dialogData.typeFilterIds = [typeClassifier_1.getId()];
                        if (filteredSubTypeIds.length > 1) {
                            dialogData.subTypeFilterIds = _this.subTypeIds;
                            return _this.openTypeSubTypeSelectDialog(dialogData);
                        }
                        else if (filteredSubTypeIds.length === 1) {
                            return _this.openNewEntityDrawer(_this.targetEntityCategoryName, { typeId: typeClassifier_1.getId(), subTypeId: filteredSubTypeIds.pop() });
                        }
                        else {
                            // No SubType filter for selected Type
                            dialogData.subTypeFilterIds = [];
                            return _this.openTypeSubTypeSelectDialog(dialogData);
                        }
                    }
                    // If there are no SubTypes for selected Type
                    return _this.openNewEntityDrawer(_this.targetEntityCategoryName, { typeId: typeClassifier_1.getId(), subTypeId: null });
                }));
            }
        }
        else {
            return this.openNewEntityDrawer(this.targetEntityCategoryName);
        }
    };
    EntitySelectPickerComponent.prototype.loadTypeClassifiers = function () {
        if (this._entityTypeConfigs) {
            if (this.typeIds.length) {
                return this.classifierService.loadClassifiersByFilter(this._entityTypeConfigs.type.category, new idm_de_core_frontend_1.FilterBuilder().in('entityId', this.typeIds).buildJson())
                    .map(function (result) { return result.getData(); });
            }
            else {
                return this.classifierService.loadAllClassifiers(this._entityTypeConfigs.type.category)
                    .map(function (result) { return result.getData(); });
            }
        }
        return of_1.of([]);
    };
    EntitySelectPickerComponent.prototype.loadSubTypeClassifiers = function (typeId) {
        return this.classifierService.loadClassifiersByParent(this._entityTypeConfigs.subType.category, typeId).map(function (result) { return result.getData(); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], EntitySelectPickerComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], EntitySelectPickerComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], EntitySelectPickerComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySelectPickerComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], EntitySelectPickerComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], EntitySelectPickerComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.FilterCriteria)
    ], EntitySelectPickerComponent.prototype, "filter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField)
    ], EntitySelectPickerComponent.prototype, "targetEntityMetaField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySelectPickerComponent.prototype, "targetEntityParentFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySelectPickerComponent.prototype, "rootCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySelectPickerComponent.prototype, "rootCategoryFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySelectPickerComponent.prototype, "typeIds", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySelectPickerComponent.prototype, "subTypeIds", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySelectPickerComponent.prototype, "WFStateIds", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], EntitySelectPickerComponent.prototype, "hasCreateButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySelectPickerComponent.prototype, "displayFields", void 0);
    EntitySelectPickerComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-entity-select-picker',
            template: require('./entity-select-picker.component.html'),
            styles: [require('./entity-select-picker.component.css')],
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 6,
            name: 'Entity Select Picker',
            settings: {
                main: entity_select_picker_settings_component_1.EntitySelectPickerSettingsComponent,
            },
            template: "<ejustice-entity-select-picker\n                    [entity]=\"entity\"\n                    [form]=\"form\"\n                    [category]=\"category\"\n                    [actionNotifier]=\"actionNotifier\"\n                    [isReadonly]=\"%{isReadonly}\"\n                    [currentLanguageId]=\"currentLanguageId\"\n                    [filter]=\"%{filter}\"\n                    [targetEntityMetaField]=\"%{targetEntityMetaField}\"\n                    [targetEntityParentFieldId]=\"%{targetEntityParentFieldId}\"\n                    [rootCategoryId]=\"%{rootCategoryId}\"\n                    [rootCategoryFieldName]=\"%{rootCategoryFieldName}\"\n                    [typeIds]=\"%{typeIds}\"\n                    [subTypeIds]=\"%{subTypeIds}\"\n                    [WFStateIds]=\"%{WFStateIds}\"\n                    [hasCreateButton]=\"%{hasCreateButton}\"\n                    [displayFields]=\"%{displayFields}\">\n                </ejustice-entity-select-picker>"
        }),
        __metadata("design:paramtypes", [idm_entity_search_client_js_1.EntitySearchService, type_configuration_service_1.TypeConfigurationService,
            form_resolution_service_1.FormResolutionService, root_category_provider_service_1.RootCategoryProviderService,
            idm_classifier_service_client_js_1.ClassifierService, idm_kb_service_client_js_1.KbService, material_1.MatDialog,
            idm_frontend_shared_1.FormResolverService, idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], EntitySelectPickerComponent);
    return EntitySelectPickerComponent;
}());
exports.EntitySelectPickerComponent = EntitySelectPickerComponent;
//# sourceMappingURL=entity-select-picker.component.js.map